import '../Cases.scss'
import { useWindowSize } from '@uidotdev/usehooks'
import type { ReactNode } from 'react'
import { Clients } from '#src/components/Clients.js'
import { DatoImage } from '#src/components/image/DatoImage.js'
import { LazyAnimation } from '#src/components/LazyAnimation.js'
import { LocalizedLink } from '#src/components/LocalizedLink.js'
import { VimeoPlayer } from '#src/components/VimeoPlayer.js'
import type { ImageGallery, VideoGallery } from '#src/data/data.js'
import type { PortfolioPageData } from '#src/pages/portfolio/portfolioData.js'
import { _chunkBalanced } from '#src/util.js'

interface Props {
  data: PortfolioPageData
  clients: string[]
  children?: ReactNode
}

export function Portfolio(props: Props): ReactNode {
  const windowSize = useWindowSize()
  const width = windowSize.width || 0
  // const width = 900 // todo: start using css for that

  const { slug, galleries } = props.data

  let numberOfColumns: number

  if (width < 431) {
    numberOfColumns = 1
  } else if (width < 832) {
    numberOfColumns = 2
  } else {
    numberOfColumns = 3
  }

  const chunkSize = Math.ceil(galleries.length / numberOfColumns)
  const columns = _chunkBalanced(galleries, chunkSize)
  // console.log(columns)
  const containerSize = Math.round(100 / numberOfColumns)

  return (
    <>
      <section className="cases-grid">
        {columns.map(galleries => (
          <div className="cases-grid__column" key={galleries[0]?.slug}>
            {galleries.map(gallery => (
              <LazyAnimation className="cases-grid__item" key={gallery.slug}>
                <LocalizedLink href={`/portfolio/${slug}/${gallery.slug}`} scroll={false}>
                  {(gallery as VideoGallery).video || (gallery as ImageGallery).videoCover ? (
                    <VimeoPlayer
                      video={
                        (gallery as VideoGallery).video || (gallery as ImageGallery).videoCover!
                      }
                      className="cases-grid__image"
                    />
                  ) : (
                    (gallery as ImageGallery).cover && (
                      <DatoImage
                        data={(gallery as ImageGallery).cover!.responsiveImage}
                        className="cases-grid__image"
                        containerSize={containerSize}
                        style={{ maxWidth: '100%' }}
                      />
                    )
                  )}
                </LocalizedLink>
              </LazyAnimation>
            ))}
          </div>
        ))}
        {/* <div className="cases-grid-end" />*/}
      </section>

      <Clients clients={props.clients} />

      {props.children}
    </>
  )
}
